var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class:
        "config-group small-12 column d-flex flex-column align-items-center",
    },
    [
      _c(
        "div",
        {
          class:
            "dropflex position-relative config-item w-100 my-auto position-relative",
        },
        [
          _vm.nested
            ? _c(
                "ul",
                { staticClass: "config-item__list r-list mt-1 ml-3" },
                [
                  _vm._l(_vm.option.auspraegungen, function (auspraegung) {
                    return [
                      _vm.isSelectable(auspraegung.id)
                        ? _c(
                            "li",
                            {
                              key: auspraegung.id,
                              staticClass: "border-bottom py-prj2",
                            },
                            [
                              _c("OptionLieferartElement", {
                                attrs: {
                                  identifier: _vm.createIdentifier(
                                    auspraegung.id
                                  ),
                                  option: _vm.option,
                                  auspraegung: auspraegung,
                                  current: _vm.currentSelection,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.$emit("input", $event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  }),
                  _vm._v(" "),
                  _vm.option.currentInfo.msgType === "INFO"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-small mt-prj text-info d-flex line-height-12",
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "mr-2 svg-icon flex-child-fix position-relative t-1px",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                x: "0",
                                y: "0",
                                viewBox: "0 0 36 36",
                                "xml:space": "preserve",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                                  fill: "#62b982",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  id: "XMLID_1_",
                                  d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.option.currentInfo.text) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.option.currentInfo.msgType === "ERROR"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-small mt-prj text-error d-flex line-height-12",
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "mr-2 svg-icon flex-child-fix position-relative t-1px",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 36 36",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "18",
                                  cy: "18",
                                  r: "18",
                                  fill: "#e94d47",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.option.currentInfo.text) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _c("div", { staticClass: "row my-children-2" }, [
                _c("div", { staticClass: "small-12 column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "config-item__info d-flex@medium align-items-center postage-addition",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-weight-light font-italic d-block@until-large text-small@until-medium ml-auto",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.option.customValues.deliveryDate) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "config-group-outline px-prj2 py-prj px-3@large border",
                    },
                    [
                      _vm._l(
                        _vm.option.auspraegungen,
                        function (auspraegung, index) {
                          return [
                            _vm.isSelectable(auspraegung.id)
                              ? [
                                  _c(
                                    "div",
                                    {
                                      key: "div" + auspraegung.id,
                                      staticClass:
                                        "config-item__info d-inline-flex flex-column py-prj2 py-prj3@large w-100",
                                    },
                                    [
                                      _c("OptionLieferartElement", {
                                        attrs: {
                                          identifier: _vm.createIdentifier(
                                            auspraegung.id
                                          ),
                                          option: _vm.option,
                                          auspraegung: auspraegung,
                                          current: _vm.liefertSelection,
                                        },
                                        model: {
                                          value: _vm.liefertSelection,
                                          callback: function ($$v) {
                                            _vm.liefertSelection = $$v
                                          },
                                          expression: "liefertSelection",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  index < _vm.option.auspraegungen.length - 1
                                    ? _c("hr", {
                                        key: "hr" + auspraegung.id,
                                        staticClass: "m-0 bg-shade",
                                      })
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _vm.option.currentInfo.msgType === "INFO"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-small mt-prj text-info d-flex line-height-12",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "mr-2 svg-icon flex-child-fix position-relative t-1px",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              x: "0",
                              y: "0",
                              viewBox: "0 0 36 36",
                              "xml:space": "preserve",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                                fill: "#62b982",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "XMLID_1_",
                                d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                                fill: "#fff",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.option.currentInfo.text) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.option.currentInfo.msgType === "ERROR"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-small mt-prj text-error d-flex line-height-12",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "mr-2 svg-icon flex-child-fix position-relative t-1px",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 36 36",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "18",
                                cy: "18",
                                r: "18",
                                fill: "#e94d47",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                                fill: "#fff",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.option.currentInfo.text) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }